export default __webpack_public_path__ + "static/media/fr.e57bbe88.svg";